module.exports = __webpack_public_path__ + "img/jsc2.c8ed433e.png";